module.exports = __webpack_public_path__ + "static/media/hollow_end_bar_tall.8846a6b0.svg";